The HTML snippet of the question being asked to the candidate.

Unsupported tags will be silently stripped when creating a questionnaire.

This field has a maximum length of 1,000 characters.
